module.exports = __webpack_public_path__ + "img/savings.7d7a67e.svg";